import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import BlogCard from "@/components/BlogCard";
import Seo from "@/components/Seo";

export default function Blogs() {
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.blogs()
      .then(setData)
      .catch(() => setData({ items: [], total: 0 }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:py-12">
      <Seo
        title="Blog"
        description="Plant care guides, gardening tips, and stories from the YourPlants.in team."
        path="/blogs"
      />
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-[var(--yp-muted)]">Blog</div>
        <h1 className="font-serif-display text-3xl sm:text-4xl text-[var(--yp-primary)]">The YourPlants Journal</h1>
      </div>

      {loading ? (
        <div className="text-center text-[var(--yp-muted)] py-24">Loading posts…</div>
      ) : data.items.length === 0 ? (
        <div className="text-center text-[var(--yp-muted)] py-24">No posts yet — check back soon.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {data.items.map((post) => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>
      )}
    </div>
  );
}
